"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SlideToggleWithIcon = function SlideToggleWithIcon(_ref) {
  var toggled = _ref.toggled,
      toggleHandler = _ref.toggleHandler,
      backgroundColorForToggledState = _ref.backgroundColorForToggledState,
      backgroundColorForUntoggledState = _ref.backgroundColorForUntoggledState,
      backgroundColorForButtonInUnToggledState = _ref.backgroundColorForButtonInUnToggledState,
      backgroundColorForButtonInToggledState = _ref.backgroundColorForButtonInToggledState,
      heightOfIconContainer = _ref.heightOfIconContainer,
      widthOfIconContainer = _ref.widthOfIconContainer,
      widthOfMainContainer = _ref.widthOfMainContainer,
      heightOfMainContainer = _ref.heightOfMainContainer,
      disabled = _ref.disabled,
      isToggleBetweenIcons = _ref.isToggleBetweenIcons,
      iconList = _ref.iconList;
  console.log(isToggleBetweenIcons);
  console.log(iconList);
  return /*#__PURE__*/_react["default"].createElement(_styled.ToggleBtnContainer, {
    onClick: toggleHandler,
    toggled: toggled,
    disabled: disabled,
    backgroundColorForToggledState: backgroundColorForToggledState,
    backgroundColorForUntoggledState: backgroundColorForUntoggledState,
    widthOfMainContainer: widthOfMainContainer,
    heightOfMainContainer: heightOfMainContainer
  }, !isToggleBetweenIcons && /*#__PURE__*/_react["default"].createElement(_styled.ToggleSlide, {
    toggled: toggled,
    disabled: disabled,
    backgroundColorForButtonInUnToggledState: backgroundColorForButtonInUnToggledState,
    backgroundColorForButtonInToggledState: backgroundColorForButtonInToggledState,
    heightOfIconContainer: heightOfIconContainer,
    widthOfIconContainer: widthOfIconContainer,
    isToggleBetweenIcons: isToggleBetweenIcons
  }), isToggleBetweenIcons && !(0, _lodash.isEmpty)(iconList) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, iconList.map(function (icon, index) {
    return /*#__PURE__*/_react["default"].createElement(_styled.ToggledIconSlide, {
      key: "some_key".concat(index),
      toggled: icon.isActive,
      iconType: icon.iconType,
      disabled: disabled,
      backgroundColorForButtonInUnToggledState: backgroundColorForButtonInUnToggledState,
      backgroundColorForButtonInToggledState: backgroundColorForButtonInToggledState,
      heightOfIconContainer: heightOfIconContainer,
      widthOfIconContainer: widthOfIconContainer,
      isToggleBetweenIcons: isToggleBetweenIcons
    });
  })));
};

var _default = SlideToggleWithIcon;
exports["default"] = _default;

//# sourceMappingURL=SlideToggleWithIcon.js.map